import React from "react";
import "./home.css";

export default function Home() {
  return (
    <div className="right-content">
      <h2 className="subheading">
        About Centre for Distance and Online Education
      </h2>
      <p>
        Centre for Distance and Online Education (CDOE), CMR University,has been
        committed to the mission of taking quality education beyond the
        traditional classroom, enabling learners from diverse backgrounds to
        pursue higher education with flexibility and academic excellence. Over
        the years, it has grown into one of the most progressive and inclusive
        Open and Distance Learning Centres in the region. CDOE, CMR University,
        offers a wide array of academic programmes including Undergraduate and
        Postgraduate degrees, Professional, Skill-based, Job-oriented, and
        Value-oriented courses that are aligned with industry trends and
        societal needs.
      </p>
      <p>
        The pedagogical approach of CDOE combines traditional and
        technology-enabled learning methods. Students are supported through
        self-learning printed materials, personal contact programmes,
        assignments, audio-visual and online content, counselling sessions,
        dissertations/projects, and academic seminars and webinars designed to
        enrich learning experiences.
      </p>
      <p>
        The Centre is supported by highly qualified and experienced faculty, who
        are deeply engaged in teaching, research, and innovation. Located within
        the scenic campus of CMR University, CDOE offers excellent facilities,
        including a well-equipped library, educational media centre, computer
        laboratories, and hostel facilities for outstation learners.
      </p>

      <p>
        Embracing the potential of Information and Communication Technology
        (ICT), CDOE is well-positioned to deliver education through both
        distance and online modes. Learners under CDOE follow the same
        curriculum, complete their programmes within the same duration, and
        appear for examinations in the same mode as regular students of CMR
        University—ensuring academic parity and quality standards.
      </p>
    </div>
  );
}
